import { Trash2, Plus, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { newItem, today } from "@/lib/api";

const Row = ({ it, i, onChange, onRemove, prefix }) => (
  <div data-testid={`${prefix}-row-${i}`} className={`grid grid-cols-[auto_1fr] sm:grid-cols-[auto_1.2fr_150px_1.5fr_auto] gap-2 items-center rounded-md border px-2 py-2 transition-colors ${it.realizada ? "bg-emerald-50/60 border-emerald-200" : "bg-white border-slate-200"}`}>
    <button
      type="button"
      data-testid={`${prefix}-done-${i}`}
      onClick={() => onChange({ ...it, realizada: !it.realizada, fecha: it.fecha || (!it.realizada ? today() : null) })}
      className={`h-6 w-6 rounded grid place-items-center border transition-colors ${it.realizada ? "bg-emerald-600 border-emerald-600 text-white" : "border-slate-300 hover:border-emerald-500"}`}
      title="Marcar como realizada"
    >
      {it.realizada && <Check className="h-4 w-4" />}
    </button>
    <Input data-testid={`${prefix}-label-${i}`} value={it.etiqueta} onChange={(e) => onChange({ ...it, etiqueta: e.target.value })} className="h-8 text-sm" />
    <Input data-testid={`${prefix}-date-${i}`} type="date" value={it.fecha || ""} onChange={(e) => onChange({ ...it, fecha: e.target.value || null })} className="h-8 text-sm col-start-2 sm:col-start-auto" />
    <Input data-testid={`${prefix}-note-${i}`} placeholder="Nota" value={it.nota} onChange={(e) => onChange({ ...it, nota: e.target.value })} className="h-8 text-sm col-start-2 sm:col-start-auto" />
    <button type="button" data-testid={`${prefix}-remove-${i}`} onClick={onRemove} className="text-slate-400 hover:text-rose-600 justify-self-end col-start-2 sm:col-start-auto">
      <Trash2 className="h-4 w-4" />
    </button>
  </div>
);

export const ItemsEditor = ({ items, onChange, prefix = "cita", addLabel = "Añadir cita", nextLabel, showToday = true, extra = null }) => {
  const update = (i, v) => onChange(items.map((x, j) => (j === i ? v : x)));
  const remove = (i) => onChange(items.filter((_, j) => j !== i));
  return (
    <div className="space-y-2">
      {items.length === 0 && <p className="text-sm text-slate-400 py-2">Sin registros todavía.</p>}
      {items.map((it, i) => (
        <Row key={it.id} it={it} i={i} prefix={prefix} onChange={(v) => update(i, v)} onRemove={() => remove(i)} />
      ))}
      <div className="flex flex-wrap gap-2 pt-1">
        <Button type="button" variant="outline" size="sm" data-testid={`${prefix}-add`} onClick={() => onChange([...items, newItem(nextLabel ? nextLabel(items) : "")])}>
          <Plus className="h-4 w-4 mr-1" /> {addLabel}
        </Button>
        {nextLabel && showToday && (
          <Button type="button" size="sm" data-testid={`${prefix}-add-today`} className="bg-[#0D9488] hover:bg-teal-700" onClick={() => onChange([...items, newItem(nextLabel(items), { fecha: today(), realizada: true })])}>
            <Check className="h-4 w-4 mr-1" /> Sesión hecha hoy
          </Button>
        )}
        {extra}
      </div>
    </div>
  );
};
